import { render, staticRenderFns } from "./BudgetPushToAfas.vue?vue&type=template&id=199677bc"
import script from "./BudgetPushToAfas.vue?vue&type=script&lang=ts"
export * from "./BudgetPushToAfas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports